import React from 'react';

import i18n from 'i18n-react';
import PropTypes from 'prop-types';

import { LoginForm, LanguageSelect } from 'C4';

import Logo from 'assets/images/logo/logo.png';
import CompanyLogo from 'assets/images/companylogo.png';
import { googleStore, appleStore } from 'settings';
import apple from 'assets/images/app_store.png';
import google from 'assets/images/google_play.png';

const MobileButtons = () => (
  <div className='button__container'>
    <div className='buttons small'>
      <a href={appleStore} target='_blank' rel='noopener noreferrer'>
        <img src={apple} alt='App store' />
      </a>
      <a href={googleStore} rel='noopener noreferrer'>
        <img src={google} alt='Google Play' />
      </a>
    </div>
  </div>
);

const LoginView = props => (
  <div className='loginView'>
    <div className='loginView__bg'>
      <div className='loginView__bg--content'>
        <h3>{i18n.translate('loginScreen.title')}</h3>
        <div className='buttonWrapper'>
          <MobileButtons />
        </div>
        <img src={CompanyLogo} alt='Company Logo' />
      </div>
    </div>
    <div className='loginView__content'>
      <img src={Logo} className='loginView__content--logo' alt='Logo' />
      <LoginForm path={props.match.path} />
    </div>
  </div>
);

export default LoginView;

LoginView.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string.isRequired,
  }),
};

LoginView.defaultProps = {
  match: {
    path: '/login',
  },
};
